import BgColorType from "@/lib/types/layout/containers/BgColor.type";
import { CSSProperties, HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  bgColor?: BgColorType;
  className?: HTMLAttributes<HTMLTableCellElement>["className"];
  colSpan?: number;
  textAlign?: CSSProperties["textAlign"];
  style?: CSSProperties;
}>;

export default function TH({
  children,
  className,
  colSpan,
  textAlign,
  bgColor,
  style,
}: Props) {
  const styles: CSSProperties = {
    backgroundColor: bgColor ? `var(--color-background-${bgColor})` : undefined,
    border: "1px solid var(--color-border-secondary)",
    fontSize: "var(--font-size-body-md)",
    padding: "var(--spacing-md)",
    textAlign: textAlign || "start",
    whiteSpace: "nowrap",
    ...style,
  };

  return (
    <th className={className} colSpan={colSpan} style={styles}>
      {children}
    </th>
  );
}
